import React from 'react';
/* import '../styles/bootstrap.min.css'; */
import css from './footer.module.scss';

const Footer = props => {
  const data = {
    name: '杭州博科思科技有限公司',
    code: '浙ICP备05076402号-1',
    address: '地址：杭州市滨江区物联网街259号初灵数据大厦19楼',
    phone: '电话：0571-87178266',
  }
  return (
    <footer className={css.footer}>
      <div className={css.name}>
        <span>{data.name}</span>
        <a className={css.code} target="blank" href="https://beian.miit.gov.cn">{data.code}</a>
      </div>
      <div className={css.address}>
        <span>{data.address}</span>
        <span>{data.phone}</span>
      </div>
    </footer>
  )
}

export default Footer;
